import { SlateStatus } from '@betterpool/api-types/games-service';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

const getIsAfterPickDeadline = (contest: FullContest, slate: ContestSlate) => {
  const isLateSwapEnabled = contest.settings?.pickDeadlineType === 'game';
  if (isLateSwapEnabled) {
    return [SlateStatus.FINISHED, SlateStatus.SETTLED].includes(slate.status);
  }

  return slate?.status !== SlateStatus.SCHEDULED;
};

export default getIsAfterPickDeadline;
